import {
	Tracker,
	TrackingEvent,
	TrackingData,
	TrackerLogger,
} from '../Tracking.events';

export class GtagTracker implements Tracker {
	// Non-optional, unlike `Window['gtag']` itself: this instance is only
	// ever constructed once `window.gtag` was already confirmed present
	// (see Tracking.tsx's initializeGtag), and every on* handler below calls
	// `this.gtag(...)` unconditionally. Falling back to a no-op instead of
	// `window.gtag` directly means a call site can't throw even in the
	// theoretical case that assumption doesn't hold.
	gtag: NonNullable<Window['gtag']>;
	constructor() {
		TrackerLogger.info(
			`Gtracker running with tracker id:`,
			window.config.analytics?.gtag?.trackerID,
		);
		this.gtag = window.gtag ?? (() => {});
	}
	sendEvent(event: TrackingEvent) {
		const { type } = event;
		console.log(event)
		switch (type) {
			case 'INSTALLED':
				this.onInstalled();
				break;
			case 'LOGIN':
				this.onLogin();
				break;
			case 'OPEN_TOC':
				this.onOpenToc();
				break;
			case 'CLOSE_TOC':
				this.onCloseToc();
				break;
			case 'SHARE':
				this.onShare(event.data);
				break;
			case 'BTN_CLICK_INSTALL':
				this.onClickInstall();
				break;
			case 'BTN_CLICK_LOGIN':
				this.onClickLogIn();
				break;
			case 'BTN_CLICK_LOGOUT':
				this.onClickLogOut();
				break;
			case 'BTN_CLICK_RESPONSIVE':
				this.onClickResponsive(event.data);
				break;
			case 'BTN_CLICK_REPLICA':
				this.onClickReplica(event.data);
				break;
			case 'BTN_CLICK_REPLICA_SINGLE':
				this.onClickReplicaSingle(event.data);
				break;
			case 'BTN_CLICK_REPLICA_DOUBLE':
				this.onClickReplicaDouble(event.data);
				break;
			case 'BTN_CLICK_FAVORITE_ARTICLE':
				this.onClickFavoriteArticle(event.data);
				break;
			case 'BTN_CLICK_UNFAVORITE_ARTICLE':
				this.onClickUnfavoriteArticle(event.data);
				break;
			case 'BTN_CLICK_ISSUE':
				this.onClickIssue(event.data);
				break;
			case 'LANGUAGE_CHANGE':
				this.onChangeLanguage(event.data);
				break;
			default:
				return;
		}
	}

	private onInstalled() {
		this.gtag('event', 'installed', {
			event_category: 'app',
			event_label: 'App is installed',
			non_interaction: true,
		});
	}

	private onLogin() {
		this.gtag('event', 'login', {
			method: 'app',
			event_category: 'session',
			event_label: 'Login',
		});
	}

	private onOpenToc() {
		this.gtag('event', 'open_toc', {
			event_category: 'issue',
			event_label: 'Open TOC',
		});
	}

	private onCloseToc() {
		this.gtag('event', 'close_toc', {
			event_category: 'issue',
			event_label: 'Close TOC',
		});
	}

	private onShare(data: TrackingData) {
		this.gtag('event', 'share', {
			method: data?.method,
			content_type: data?.contentType,
			item_id: data?.article?.ArticleID,
		});
	}

	private onClickInstall() {
		this.gtag('event', 'click_install', {
			event_category: 'session',
			event_label: 'Click install',
		});
	}

	private onClickLogIn() {
		this.gtag('event', 'login', {
			event_category: 'session',
			event_label: 'Login',
		});
	}

	private onClickLogOut() {
		this.gtag('event', 'logout', {
			event_category: 'session',
			event_label: 'Log out',
		});
	}

	private onClickResponsive(_data: TrackingData) {
		this.gtag('event', 'click_responsive', {
			event_category: 'issue',
			event_label: 'Click Responsive',
		});
		// this.gtag.push('event', 'responsive', data);
	}

	private onClickReplica(_data: TrackingData) {
		this.gtag('event', 'click_replica', {
			event_category: 'issue',
			event_label: 'Click Replica',
		});
		// this.gtag.push('event', 'replica', data);
	}

	private onClickReplicaSingle(_data: TrackingData) {
		this.gtag('event', 'replica_single', {
			event_category: 'issue',
			event_label: 'Click Single Page Replica',
		});
		// this.gtag.push('event', 'replica_single', data);
	}

	private onClickReplicaDouble(_data: TrackingData) {
		this.gtag('event', 'replica_double', {
			event_category: 'issue',
			event_label: 'Click Double Page Replica',
		});
		// this.gtag.push('event', 'replica_double', data);
	}

	private onClickFavoriteArticle(_data: TrackingData) {
		this.gtag('event', 'favorie_article', {
			event_category: 'article',
			event_label: 'Click Favorite Article',
		});
		// this.gtag.push('event', 'favorite', data);
	}

	private onClickUnfavoriteArticle(_data: TrackingData) {
		this.gtag('event', 'unfavorie_article', {
			event_category: 'article',
			event_label: 'Click Unfavorite Article',
		});
		// this.gtag.push('event', 'unfavorite', data);
	}

	private onClickIssue(_data: TrackingData) {
		this.gtag('event', 'click_issue', {
			event_category: 'article',
			event_label: 'Click Issue',
		});
		// this.gtag.push('event', 'unfavorite', data);
	}

	private onChangeLanguage(_data: TrackingData) {
		this.gtag('event', 'change_language', {
			event_category: 'article',
			event_label: 'Change language',
		});
	}
}
